import request from '../../config/axiosConfig';
import {
  GET_LIST_FEATURE_RATING_CONFIGS,
  CREATE_FEATURE_RATING_CONFIG,
  UPDATE_FEATURE_RATING_CONFIG,
  DELETE_FEATURE_RATING_CONFIG,
  GET_DETAIL_FEATURE_RATING_CONFIG,
} from '../../constants/apiEndPoint';

const featureRatingConfigService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_LIST_FEATURE_RATING_CONFIGS, method: 'POST', data: params });
    return data;
  },

  getDetail: async (id) => {
    const { data } = await request({ url: GET_DETAIL_FEATURE_RATING_CONFIG, method: 'POST', data: { id } });
    return data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_FEATURE_RATING_CONFIG, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_FEATURE_RATING_CONFIG, method: 'POST', data: { ...dataBody, id } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_FEATURE_RATING_CONFIG, method: 'POST', data: { id } });
    return data;
  },
};

export default featureRatingConfigService;

